export default __webpack_public_path__ + "static/media/warning.29ca4111.svg";